export default {
    user: null
}
